import { useState } from 'react';
import { Button, Group, Paper, Stack, Text, Textarea } from '@mantine/core';
import { useMutation } from 'urql';
import { ErrorAlert } from '@/components/error-alert';
import { getErrorMessage } from '@/lib/error-message';
import { UpdatePersonaMutation } from './graphql';
import type { PersonaDetail } from './graphql';

export function PersonaInstructionsPanel({ persona }: { persona: PersonaDetail }) {
  const [, runUpdatePersona] = useMutation(UpdatePersonaMutation);

  const [instructions, setInstructions] = useState(persona.instructions);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSave = async () => {
    setIsSaving(true);
    setError(null);

    const result = await runUpdatePersona({ personaId: persona.id, set: { instructions } });

    setIsSaving(false);
    setError(result.error ? getErrorMessage(result.error, 'Failed to save instructions') : null);
  };

  return (
    <Paper p="lg" withBorder radius="lg">
      <Stack gap="md">
        <ErrorAlert message={error} />
        <Text size="sm" c="dimmed">
          These instructions define how the AI agent behaves. Be specific about the persona&apos;s role, tone, and
          goals.
        </Text>
        <Textarea
          label="System Instructions"
          description="The AI's personality, knowledge, and behavior guidelines"
          value={instructions}
          onChange={(e) => setInstructions(e.target.value)}
          minRows={12}
          autosize
        />
        <Group justify="flex-end">
          <Button onClick={handleSave} loading={isSaving}>
            Save Instructions
          </Button>
        </Group>
      </Stack>
    </Paper>
  );
}
